// @flow

import { PersistenceRegistry, ReducerRegistry, set } from "../base/redux";

import * as actionTypes from "./actionTypes";

/**
 * The name of the redux store/state property which is the root of the redux
 * state of the feature {@code goidd}.
 */
const STORE_NAME = "features/nxatel";

/**
 * Sets up the persistence of the feature {@code goidd}.
 */
PersistenceRegistry.register(STORE_NAME, {
    countries: [],
    upcoming_meetings: [],
    past_meetings: [],
    meetingDetails: {},
    userStatusList: {},
    activeUrl: "auth",
    chatWindowUsers: [],
    sideNavbarMemberList: [],
    resetPasswordToken: "",
    userDetails: {},
    meeting_count: {},    
    selected_chat_user: {},
    follower_details: {},
    open_main_page_section: {},
    user_details: {},
    create_group_member:{}, 
    team_name:{},
    fetch_team_chat:{},
    device_product_item:[],
    navigate_to_buy:{},
    fetch_total_cost:{},
    navigate_to_order_items:{},
    navigate_to_notes:[],
    navigate_to_call_info : {},
    navigate_to_schedule_meeting:{}  ,
    chat_info:{}  ,
    group_uniquekey:{},
    navigate_to_setting:{},
    navigate_to_planner:{},
    navigate_to_power_apps:{},
    data:[],
    selected_plan_during_signup:{},
    is_demo_booking:{},   
});

const DEFAULT_STATE = {
    countries: [],
    upcoming_meetings: [],
    past_meetings: [],
    meetingDetails: {},
    userStatusList: {},
    activeUrl: "auth",
    chatWindowUsers: [],
    sideNavbarMemberList: [],
    resetPasswordToken: "",
    userDetails: {},
    meeting_count: {},
    total_meetings: {},
    follower_details: [],
    followers_listing: [],
    selected_chat_user: {},
    extension_list: [],
    loader: false,
    open_main_page_section: {},
    days_and_dates: [],
    meeting_list: [],
    recent_call_list: [],
    all_recording_list: [],
    user_details: {},
    phonesystem_team:[],
    voicefile_list:[],
    selected_group_chat_user:{},
    selected_chat_type:"", 
    navigate_to_phonesystem:{}, 
    device_product_item:[],
    navigate_to_buy:{},
    fetch_total_cost:{},
    navigate_to_order_items:{},
    navigate_to_notes:[],
    navigate_to_call_info:{},
    navigate_to_schedule_meeting:{},
    sub_pages:"login",
    sub_tabs:"",
    chat_info:{},
    group_uniquekey:{},
    navigate_to_setting:{},
    navigate_to_planner:{},
    navigate_to_power_apps:{},
    data:[],
    google_maps_address:{},
    knockingList:[],
    _visible:false,
    address_verified:false,
    selected_plan_during_signup:{},
    is_demo_booking:{},  
    get_full_screen_userid:"", 
    additional_moderator:[],
    activate_guest_share_screen:[],
    is_recording_on:[]
};

/**
 * Reduces redux actions for the purposes of the feature {@code goidd}.
 */
ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case actionTypes.SHOW_LOADER: 
            return {
                ...state,
                loader: action.payload,
            };
        case actionTypes.GET_COUNTRIES_LIST:
            return {
                ...state,
                countries: action.payload,
            }; 
        case actionTypes.FTECH_FOLLOWERS_LISTING: 
            return {
                ...state,
                followers_listing: action.payload,
            };
        case actionTypes.SELECTED_CHAT_USER:
            return {
                ...state,
                selected_chat_user: action.payload,
            };
        case actionTypes.OPEN_CHAT_INFO_PAGE:
            return {
                ...state,
                chat_info: action.payload,
            };
        case actionTypes.GOOGLE_MAP_ADDRESS:            
            return {
                ...state, 
                google_maps_address:action.payload
            }
        case actionTypes.SELECTED_GROUP_CHAT_USER:
            return {
                ...state,
                selected_group_chat_user: action.payload,
            };
        case actionTypes.SELECTED_CHAT_TYPE: 
            return {
                ...state,
                selected_chat_type: action.payload,
            }; 
        case actionTypes.NAVIGATE_TO_PHONESYSTEM:  
            return {
                ...state,
                navigate_to_phonesystem: action.payload,
            }; 
        case actionTypes.NAVIGATE_TO_BUY:  
            return {
                ...state,
                navigate_to_buy: action.payload,
            };
        case actionTypes.NAVIGATE_TO_BUY:  
            return {
                ...state,
                navigate_to_buy: action.payload,
            }; 
        case actionTypes.NAVIGATE_TO_CALL_INFO:  
            return {
                ...state,
                navigate_to_call_info: action.payload,
            }; 
        case actionTypes.FETCH_GROUP_UNIQUEKEY:  
            return {
                ...state,
                group_uniquekey: action.payload,
            }; 
        case actionTypes.NAVIGATE_TO_SCHEDULE_MEETING:  
            return {
                ...state,
                navigate_to_schedule_meeting: action.payload,
            }; 
        case actionTypes.NAVIGATE_TO_ORDER_ITEMS:   
            return {
                ...state,
                navigate_to_order_items: action.payload,
            };
        case actionTypes.NAVIGATE_TO_POWER_APPS:   
            return {
                ...state,
                navigate_to_power_apps: action.payload,
            };
        case actionTypes.FETCH_TOTAL_AMOUNT: 
            return {
                ...state,
                fetch_total_cost: action.payload,
            }; 
        case actionTypes.NAVIGATE_TO_NOTES: 
            return {
                ...state,
                navigate_to_notes: action.payload,
            }; 
        case actionTypes.TEAM_NAME:
            return {
                ...state,
                team_name: action.payload,
            };
        case actionTypes.FETCH_TEAM_CHAT:
            return {
                ...state,
                fetch_team_chat: action.payload,
            };
        case actionTypes.CREATE_GROUP_MEMBER:
            return {
                ...state,
                create_group_member: action.payload,
            };
        case actionTypes.SET_USER_DETAIL:
            return {
                ...state,
                userDetails: action.payload,
            };
        case actionTypes.MEETING_DETAIL:
            return {
                ...state,
                meetingDetails: action.payload,
            };
        case actionTypes.CHANGE_URL:
            return {
                ...state,
                activeUrl: action.payload,
            };
        case actionTypes.MEETING_COUNTS:
            return {
                ...state,
                meeting_count: action.payload,
            };
        case actionTypes.TOTAL_MEETINGS:
            return {
                ...state,
                total_meetings: action.payload,
            };
        case actionTypes.NAVIGATE_TO_SETTING:
            return {
                ...state,
                navigate_to_setting: action.payload,
            };
        case actionTypes.NAVIGATE_TO_PLANNER:
            return {
                ...state,
                navigate_to_planner: action.payload,
            };
        case actionTypes.FOLLOWER_WEEKLY_DETAILS:
            return {
                ...state,
                follower_details: action.payload,
            };
        case actionTypes.UPCOMING_MEETING_LIST:
            return {
                ...state,
                upcoming_meetings: {
                    list: action.payload.data,
                    total_rows: action.payload.totalRows,
                },
            };
        case actionTypes.FTECH_DAYS_AND_DATES:
            return {
                ...state,
                days_and_dates: action.payload,
            };
        case actionTypes.FTECH_MEETING_LISTING:
            return {
                ...state,
                meeting_list: action.payload,
            };
        case actionTypes.OPEN_MAIN_PAGE_SECTION: // TILL THIS LINE ALL ORG
            return {
                ...state,
                open_main_page_section: action.payload,
            };
        case actionTypes.PAST_MEETING_LIST:
            return {
                ...state,
                past_meetings: {
                    list: action.payload.data,
                    total_rows: action.payload.totalRows,
                },
            };
        case actionTypes.USER_STATUS:
            const { userStatusList } = state;
            const { state: status, user } = action.payload;
            userStatusList[user] = status;
            return {
                ...state,
                userStatusList: { ...userStatusList },
            };
        case actionTypes.USER_OFFLINE_STATUS:
            const { userStatusList: presenceState } = state;
            const { user: u } = action.payload;
            delete presenceState[u];
            return {
                ...state,
                userStatusList: { ...presenceState },
            };
        case actionTypes.CHAT_WINDOW_USERS:
            const { chatWindowUsers } = state;
            let filteredUsers = chatWindowUsers;
            const index = filteredUsers.findIndex(
                (item) => item.uuid === action.payload.uuid
            );
            if (index === -1) {
                filteredUsers = [...filteredUsers, action.payload];
            }
            if (filteredUsers.length >= 5) {
                filteredUsers.shift();
            }
            return {
                ...state,
                chatWindowUsers: [...filteredUsers],
            };
        case actionTypes.REMOVE_CHAT_WINDOW_USER:
            const { chatWindowUsers: users } = state;
            const filteredUserData = users.filter(
                (user) => user.uuid !== action.payload
            );
            return {
                ...state,
                chatWindowUsers: [...filteredUserData],
            };
        case actionTypes.SIDE_NAVBAR_MEMBER_LIST:
            const data = action.payload || [];
            const dataWithStatus = data.map((v) => ({
                ...v,
                presence: "offline",
            }));
            return {
                ...state,
                sideNavbarMemberList: [...dataWithStatus],
            };
        case actionTypes.SET_RESET_PASSWORD_TOKEN:
            return {
                ...state,
                resetPasswordToken: action.payload,
            };
        case actionTypes.FETCH_USER_DETAILS:
            return {
                ...state,
                user_details: action.payload,
            };
        case actionTypes.PHONESYSTEM_TEAM:
            return {
                ...state,
                phonesystem_team: action.payload,
            };
        case actionTypes.FETCH_DEVICE_PRODUCT_CART:
            return {
                ...state,
                device_product_item: action.payload,
            };
        case actionTypes.SUB_PAGES:
            return {
                ...state,
                sub_pages: action.payload,
            };
        case actionTypes.SUB_TABS:
            return {
                ...state,
                sub_tabs: action.payload,
            };
        case actionTypes.IS_VISIBLE_LOBBY:
            return {
                ...state,
                _visible: action.payload,
            };
        case actionTypes.KNOCKING_LIST_LOBBY:
            return {
                ...state,
                knockingList: action.payload,
            };
        case actionTypes.ADDRESS_VERIFIED:
            return {
                ...state,
                address_verified: action.payload,
            };
        case actionTypes.SELECTED_PLAN_DURING_SIGNUP:
            return {
                ...state,
                selected_plan_during_signup: action.payload,
            };
        case actionTypes.IS_NXA_DEMO_BOOKING:
            return {
                ...state,
                is_demo_booking: action.payload,
            }; 
        case actionTypes.GET_FULL_SCREEN_USERID:
            return {
                ...state,
                get_full_screen_userid: action.payload,
            };
        case actionTypes.ACTIVATE_GUEST_SHARE_SCREEN:  
            return {
                ...state,
                activate_guest_share_screen: action.payload,
            };
        case actionTypes.ADDITIONAL_MODERATOR:  
            return {
                ...state,
                additional_moderator: action.payload,
            };
        case actionTypes.IS_RECORDING_ON:  
            return {
                ...state,
                is_recording_on: action.payload,
            };
        default:
            return state;
    }
});
